<template>
  <div>
    
  </div>
</template>

<script>
export default { 
  data () {
    return {
      msg: ''
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/User/add.vue